"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _typography = require("../Typography/typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DONE_LEGACY_ICON = _react.default.createElement("i", {
  className: "co-icon co-icon__co-nav",
  "aria-hidden": "true",
  "data-co-icon": "done"
}, "done");

var ERROR_LEGACY_ICON = _react.default.createElement("i", {
  className: "co-icon co-icon__co-nav",
  "aria-hidden": "true",
  "data-co-icon": "priority_high"
}, "priority_high");

var EMPTY_ICON = _react.default.createElement("i", {
  className: "co-icon co-icon__co-nav",
  "aria-hidden": "true"
});

function getIcon(_ref) {
  var error = _ref.error,
      active = _ref.active,
      completed = _ref.completed;
  var showIcon = active || error || completed;
  if (!showIcon) return null;
  if (error) return ERROR_LEGACY_ICON;
  if (completed) return DONE_LEGACY_ICON;
  return EMPTY_ICON;
}

var WizardNavItem = function WizardNavItem(_ref2) {
  var children = _ref2.children,
      onClick = _ref2.onClick,
      active = _ref2.active,
      completed = _ref2.completed,
      disabled = _ref2.disabled,
      error = _ref2.error,
      errorMessage = _ref2.errorMessage;
  var isClickable = !disabled && onClick;
  var styles = (0, _classnames.default)({
    'co-nav--active': active,
    'co-nav--completed': completed && !error,
    'co-nav--disabled': disabled,
    'co-nav--error': error,
    'co-nav--error-message': errorMessage,
    selectable: isClickable
  });

  var clickHandler = function clickHandler(e) {
    e.stopPropagation();

    if (isClickable) {
      onClick();
    }
  };

  return _react.default.createElement("li", {
    className: styles,
    onClick: clickHandler
  }, errorMessage ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
    className: "co-nav--item"
  }, _react.default.createElement("span", null, children), getIcon({
    error: error,
    completed: completed,
    active: active
  })), _react.default.createElement(_typography.Paragraph, null, errorMessage)) : _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("span", null, children), getIcon({
    error: error,
    completed: completed,
    active: active
  })));
};

WizardNavItem.propTypes = {
  children: _propTypes.node.isRequired,
  onClick: _propTypes.func,
  active: _propTypes.bool,
  completed: _propTypes.bool,
  disabled: _propTypes.bool,
  error: (0, _airbnbPropTypes.requiredBy)('errorMessage', _propTypes.bool),
  errorMessage: _propTypes.string
};
var _default = WizardNavItem;
exports.default = _default;
WizardNavItem.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "WizardNavItem",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "active": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "completed": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "error": {
      "type": {
        "name": "custom",
        "raw": "requiredBy('errorMessage', bool)"
      },
      "required": false,
      "description": ""
    },
    "errorMessage": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};